import { Link, useLocation } from 'react-router-dom';
import headerLogo from '../assets/images/header-logo.png';
import currencyIcon from '../assets/images/currency-icon.png';
import searchIcon from '../assets/images/search-icon.png';
import notificationIcon from '../assets/images/notification-icon.png';
import favoriteIcon from '../assets/images/favorite-icon.png';

const links = ['Home', 'Properties', 'Contact us'];

function Header() {
  const location = useLocation();

  const isLinkActive = (link) => {
    if (link === 'Home') {
      return location.pathname === '/';
    }

    if (link === 'Properties') {
      return location.pathname.startsWith('/properties');
    }

    if (link === 'Contact us') {
      return location.pathname.startsWith('/contact');
    }

    return false;
  };

  return (
    <header className="site-header">
      <Link to="/" className="brand">
        <img src={headerLogo} alt="Dream Home" />
        <span>Dream Home</span>
      </Link>

      <nav className="header-nav">
        {links.map((link) => {
          const className = isLinkActive(link) ? 'active' : '';

          if (link === 'Home') {
            return (
              <Link key={link} to="/" className={className}>
                {link}
              </Link>
            );
          }

          if (link === 'Properties') {
            return (
              <Link key={link} to="/properties" className={className}>
                {link}
              </Link>
            );
          }

          if (link === 'Contact us') {
            return (
              <Link key={link} to="/contact" className={className}>
                {link}
              </Link>
            );
          }

          return (
            <a key={link} href="#/" className={className}>
              {link}
            </a>
          );
        })}
      </nav>

      <div className="header-actions">
        <button className="currency-pill">
    {/*       <img src={currencyIcon} alt="" />
          <span>Curr.</span> */}
        </button>
        <button className="outline-button" aria-label="Search">
        {/*   <img src={searchIcon} alt="" /> */}
        </button>
        <button className="outline-button" aria-label="Notifications">
    {/*       <img src={notificationIcon} alt="" /> */}
        </button>
        <button className="outline-button" aria-label="Favorites">
         {/*  <img src={favoriteIcon} alt="" /> */}
        </button>
  
      </div>
    </header>
  );
}

export default Header;
